import React from 'react';
import { Image } from 'src/lib/StyledComponents';

const Logo = () => (
	<Image
		src="/wisely_logo.png"
		alt="Wisely logo"
		width="200px"
		marginBottom="40px"
		marginTop="40px"
	/>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/utils/Logo/index.js